import { AxiosResponse } from "axios";

export default function downloadFile(
  { data, headers }: AxiosResponse,
  defaultFileName: string = "unknown",
  defaultContentType = "application/octet-stream",
): void {
  const fileName = fileNameFromContentDisposition(headers["content-disposition"]) || defaultFileName;
  if (!fileName) {
    throw new Error("Given file name cannot be empty.");
  }
  const downloadUrl = window.URL.createObjectURL(
    new Blob([data], { type: headers["content-type"] || defaultContentType }),
  );
  const link = document.createElement("a");
  link.href = downloadUrl;
  link.setAttribute("download", fileName);
  link.click();
  setTimeout(() => window.URL.revokeObjectURL(downloadUrl), 0);
}

function fileNameFromContentDisposition(disposition: string): string | null {
  const utf8FilenameRegex = /filename\*=UTF-8''([\w%\-.]+)(?:; ?|$)/;
  const asciiFilenameRegex = /filename=(["']?)(.*?[^\\])\1(?:; ?|$)/;

  let fileName = null;
  if (utf8FilenameRegex.test(disposition)) {
    fileName = decodeURIComponent(utf8FilenameRegex.exec(disposition)![1]);
  } else {
    const matches = asciiFilenameRegex.exec(disposition);
    if (matches && matches[2]) {
      // eslint-disable-next-line prefer-destructuring
      fileName = matches[2];
    }
  }
  return fileName;
}
